// extracted by mini-css-extract-plugin
module.exports = {"BlogHeader":"BlogHeader_BlogHeader__ZUpC_","BlogHeader__heading":"BlogHeader_BlogHeader__heading__tdfHY","BlogHeader__content":"BlogHeader_BlogHeader__content__YLJiT"};